export default __webpack_public_path__ + "static/media/misile.c3d594eb.gif";